import { getProviders, getProvidersAxios } from '@/api/providers.js';
import constants from '@/constants';
import { sortByName } from '@/scripts/tools';

export default {
    state: {
        providers: [],
        defaultProvider: constants.DEFAULT_PROVIDER,
    },
    getters: {
        PROVIDERS: (state) => {
            return state.providers;
        },
        DEFAULT_PROVIDER: (state) => {
            return state.defaultProvider;
        },
        PROVIDER_BY_ID: (state) => (id) => {
            const providerIndex = state.providers
                .map((provider) => provider.id)
                .indexOf(id);
            if (providerIndex >= 0) return state.providers[providerIndex];
            else return null;
        },
        PROVIDER_COUNT: (state) => {
            return state.providers.length;
        },
    },
    mutations: {
        PROVIDERS: (state, payload) => {
            payload.sort((a, b) => sortByName(a, b));
            state.providers = payload;
        },
        PROVIDER_PUSH: (state, payload) => {
            state.providers.push(structuredClone(payload));
        },
        PROVIDER_UPDATE: (state, { id, payload }) => {
            const providerIndex = state.providers
                .map((provider) => provider.id)
                .indexOf(id);
            if (providerIndex >= 0) {
                state.providers[providerIndex] = structuredClone(payload);
            }
        },
        PROVIDER_SPLIT: (state, id) => {
            const providerIndex = state.providers
                .map((provider) => provider.id)
                .indexOf(id);
            if (providerIndex >= 0) state.providers.splice(providerIndex, 1);
        },
    },
    actions: {
        CHECK_PROVIDER: async function (context) {
            if (context.getters.PROVIDERS.length === 0) {
                context.commit('PROVIDERS', await getProviders());
            }
        },
        CHECK_PROVIDER_AXIOS: async function (context) {
            if (context.getters.PROVIDERS.length === 0) {
                const axiosPromise = await getProvidersAxios().catch(
                    (error) => {
                        return null;
                    }
                );
                return axiosPromise;
            }
            return null;
        },
    },
};
